import React from 'react';

import { BILLBOARD, CAMPAIGNS, KPIS, PRODUCTS, SALESORDERS } from 'constants/Entities';
import { lazyRoute } from 'utils/lazyRoute';

import { EXTERNAL_ROUTE_METADATA, INTERNAL_ROUTE_METADATA } from './routeMetadata';

const Login = lazyRoute(() => import('containers/Login'));
const Logout = lazyRoute(() => import('containers/Logout'));
const RecoverPassword = lazyRoute(() => import('containers/RecoverPassword'));
const ExpiredPassword = lazyRoute(() => import('containers/ExpiredPassword'));
const ChangePassword = lazyRoute(() => import('containers/ChangePassword'));
const ContractsValidation = lazyRoute(() => import('containers/ContractsValidation'));
const SignatureConfirm = lazyRoute(() => import('containers/SignatureConfirm'));
const ForceBIMobile = lazyRoute(() => import('containers/DashboardForceBI/ForceBIMobile'));
const UnsubscribedSuccessful = lazyRoute(
    () => import('containers/campaigns/marketing/UnsubscribedSuccessful'),
);
const AcceptInvite = lazyRoute(() => import('containers/AcceptInvite'));
const SageMobileInvite = lazyRoute(() => import('containers/SageMobileInvite'));
const SageMobileSuccess = lazyRoute(() => import('containers/SageMobileSuccess'));
const SageMobileError = lazyRoute(() => import('containers/SageMobileError'));
const OnboardingWizard = lazyRoute(() => import('containers/OnboardingWizard'));
const S200ukiOnboarding = lazyRoute(() => import('containers/S200ukiOnboarding'));
const Auth = lazyRoute(() => import('containers/Auth'));
const ErrorPage = lazyRoute(() => import('containers/Error'));

const Opportunities = lazyRoute(() => import('containers/opportunities'));
const Companies = lazyRoute(() => import('containers/companies'));
const Contacts = lazyRoute(() => import('containers/contacts'));
const Campaigns = lazyRoute(() => import('containers/campaigns'));
const SalesOrders = lazyRoute(() => import('containers/SalesOrders'));
const Documents = lazyRoute(() => import('containers/documents'));
const Billboard = lazyRoute(() => import('containers/Billboard'));
const Reports = lazyRoute(() => import('containers/reports'));
const Kpis = lazyRoute(() => import('containers/kpis'));
const Agenda = lazyRoute(() => import('containers/agenda'));
const Activities = lazyRoute(() => import('containers/Activities'));
const Metrics = lazyRoute(() => import('containers/Metrics'));
const Products = lazyRoute(() => import('containers/Products'));
const MetricsDashboardView = lazyRoute(() => import('containers/Metrics/MetricsDashboardView'));
const MetricsSFMView = lazyRoute(() => import('containers/Metrics/MetricSFMView'));
const Settings = lazyRoute(() => import('containers/settings'));
const CustomPage = lazyRoute(() => import('containers/CustomPage'));
const Dashboard = lazyRoute(() => import('containers/Dashboard'));
const Placeholder = lazyRoute(() => import('containers/Placeholder'));

const EXTERNAL_ROUTE_COMPONENTS = {
    acceptInvite: AcceptInvite,
    auth: Auth,
    changePassword: ChangePassword,
    contractsValidation: ContractsValidation,
    emailUnsubscribed: UnsubscribedSuccessful,
    error: ErrorPage,
    errorCode: ErrorPage,
    expiredPassword: ExpiredPassword,
    login: Login,
    logout: Logout,
    onboarding: OnboardingWizard,
    recoverPassword: RecoverPassword,
    s200ukiOnboarding: S200ukiOnboarding,
    sageMobileError: SageMobileError,
    sageMobileErrorCode: SageMobileError,
    sageMobileInvite: SageMobileInvite,
    sageMobileSuccess: SageMobileSuccess,
    salesBiMobile: ForceBIMobile,
    signatureConfirm: SignatureConfirm,
};

const INTERNAL_ROUTE_COMPONENTS = {
    activities: Activities,
    agenda: Agenda,
    billboard: Billboard,
    campaigns: Campaigns,
    companies: Companies,
    contacts: Contacts,
    conversationActivities: Activities,
    customPage: CustomPage,
    dashboard: Dashboard,
    documents: Documents,
    kpis: Kpis,
    metrics: Metrics,
    metricsDashboard: MetricsDashboardView,
    metricsSfm: MetricsSFMView,
    opportunities: Opportunities,
    products: Products,
    reports: Reports,
    salesOrders: SalesOrders,
    settings: Settings,
    tryBillboard: Placeholder,
    tryCampaigns: Placeholder,
    tryKpis: Placeholder,
    tryProducts: Placeholder,
    trySalesOrders: Placeholder,
};

const INTERNAL_ROUTE_PROPS = {
    tryBillboard: { entity: BILLBOARD },
    tryCampaigns: { entity: CAMPAIGNS },
    tryKpis: { entity: KPIS },
    tryProducts: { entity: PRODUCTS },
    trySalesOrders: { entity: SALESORDERS },
};

const createRoute = (metadata, components, routeProps = {}) => {
    const Component = components[metadata.id];
    return {
        ...metadata,
        element: <Component {...routeProps[metadata.id]} />,
    };
};

export const EXTERNAL_ROUTES = EXTERNAL_ROUTE_METADATA.map((metadata) =>
    createRoute(metadata, EXTERNAL_ROUTE_COMPONENTS),
);

export const ROUTES = INTERNAL_ROUTE_METADATA.map((metadata) =>
    createRoute(metadata, INTERNAL_ROUTE_COMPONENTS, INTERNAL_ROUTE_PROPS),
);
